// @owners { team: patients }
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { get } from '~shared/helpers/apiHelper';
import { queryClient } from '~shared/react-query/queryClient';
import { type ShipmentPaymentMethod } from '~shared/types';

export const shipmentPaymentMethods = createQueryKeys('shipmentPaymentMethods', {
  fetchAll: () => ({
    queryKey: ['fetch-all-shipment-payment-methods'],
    queryFn: async () => {
      const response = await get('/shipment_payment_methods');
      if (response.error) {
        throw new Error(response.error.message);
      }
      return response as ShipmentPaymentMethod[];
    },
  }),
});

/**
 * Invalidate the shipment-payment-methods query so any active observer (the bridge at the
 * authed root) refetches. Store-free so action files (e.g. `deliveries`) can call it without
 * pulling the store into their import graph — avoids the store↔actions circular import.
 *
 * Shipment payment methods can be created server-side by care ops (Wunderbar) outside the
 * patient's session, so we re-fetch after a deliveries fetch to avoid showing stale data.
 */
export const invalidateShipmentPaymentMethods = () =>
  queryClient.invalidateQueries({ queryKey: shipmentPaymentMethods.fetchAll().queryKey });
